import { Card, Typography } from 'antd';
import { FileTextOutlined, SafetyCertificateOutlined, AuditOutlined, SolutionOutlined, EyeOutlined, ClockCircleOutlined } from '@ant-design/icons';
import s from './index.module.css';

const { Text } = Typography;

// 图标映射
const iconMap = {
  'icon-file-text': <FileTextOutlined />,
  'icon-safety-certificate': <SafetyCertificateOutlined />,
  'icon-audit': <AuditOutlined />,
  'icon-solution': <SolutionOutlined />
};

// 图标列表
const iconKeys = Object.keys(iconMap);

// 随机获取一个图标
const getStableIcon = (seed = '') => {
  const text = String(seed || '').trim();
  if (!text) return iconKeys[0];

  const hash = Array.from(text).reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return iconKeys[hash % iconKeys.length];
};

// 格式化浏览量
const formatViews = (count) => {
  if (count >= 10000) {
    return `${(count / 10000).toFixed(1)}万`;
  }
  return count.toString();
};

const desc = '本办法适用于检验检测机构的监督管理，旨在规范检验检测机构的检验检测行为，提高检验检测机构的技术能力和管理水平，维护检验检测市场秩序，保护消费者合法权益。本办法所称检验检测机构，是指依法成立，依据相关标准或者技术规范，利用仪器设备、环境设施等技术条件和专业技能，对产品或者法律法规规定的特定对象进行检验检测的专业技术组织。';

const KnowledgeCard = ({ icon, title, description, onClick, publishTime, views }) => {
  // 如果没有提供 icon，则根据标题稳定映射一个图标，避免滚动重渲染时闪烁
  const selectedIcon = icon || getStableIcon(title);

  return (
    <Card
      className={s.knowledgeCard}
      hoverable
      onClick={onClick}
      bodyStyle={{ padding: '24px' }}
    >
      <div className={s.knowledgeCardContent}>
        <div className={s.knowledgeCardIcon}>
          {iconMap[selectedIcon] || <i className={`iconfont ${selectedIcon}`} />}
        </div>
        <div className={s.knowledgeCardText}>
          <h4 className={s.knowledgeCardTitle}>{title}</h4>
        </div>
      </div>
      <Text className={s.knowledgeCardDescription} type="secondary">
        {description || desc}
      </Text>
      {(publishTime || views !== undefined) && (
        <div className={s.knowledgeMeta}>
          {publishTime && (
            <div className={s.metaItem}>
              <ClockCircleOutlined className={s.metaIcon} />
              <span>{publishTime}</span>
            </div>
          )}
          {views !== undefined && (
              <div className={s.metaItem}>
                <EyeOutlined className={s.metaIcon} />
                <span>{formatViews(views)}</span>
              </div>
          )}
        </div>
      )}
    </Card>
  );
};

export default KnowledgeCard;
